import { valuePropCarousel as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';
import { ValuePropCarouselProps } from '.';

const TestData: ValuePropCarouselProps = {
  eyebrow: 'Our Culture',
  header: 'What sets us apart and keeps us together.',
  backgroundColor: false,
  valuePropCardContent: [
    {
      cardImage: '/assets/test.png',
      cardHeadline: 'Happiness Committe',
      cardDescription:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit',
    },
    {
      cardImage: '/assets/test.png',
      cardHeadline: 'Some Other Title',
      cardDescription:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit',
    },
    {
      cardImage: '/assets/test.png',
      cardHeadline: 'Third Slide',
      cardDescription:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit',
    },
    {
      cardImage: '/assets/test.png',
      cardHeadline: 'Fourth Slide',
      cardDescription:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit',
    },
  ],
};

export default fakeProps(schema, TestData);
